import { useCallback, useEffect, useState } from 'react'
import { useAuctionContract } from './useContract'

const useGetAuction = (address: string, tokenId: string) => {
  const contractMethod = useAuctionContract()
  const [data, setData] = useState<any>(null)

  const getData = useCallback(async () => {
    if (contractMethod && tokenId) {
      try {
        const res = await contractMethod.tokenIdToAuction(address, tokenId)

        setData(res)
      } catch (error) {
        console.error(error)
      }
    }
  }, [address, contractMethod, tokenId])

  useEffect(() => {
    getData()
  }, [getData])

  return [data, getData]
}

export default useGetAuction
